import React, { useState, useEffect, useCallback,useRef } from "react";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { CheckBox } from 'devextreme-react/check-box';
import { Button } from 'devextreme-react/button';
import SelectBox from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import { connect } from "react-redux";
import { confirm } from "devextreme/ui/dialog";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import ArrayStore from 'devextreme/data/array_store';
import { HubConnectionBuilder } from "@microsoft/signalr";
import Popup from 'devextreme-react/popup';
import { GridLayout } from "../../../common/GridLayout";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { handleDataGridExport } from "../../../common/Utils";

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    SelectionState,
    Editing,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring
} from "devextreme-react/data-grid";

let accessToken = '';
let recordSelectionDic = {};

const PullOrderGrid = (props) => {
    const dataGrid = useRef(null);
    let ignoreSelectionChange = false;
    const [processCodes, setProcessCodes] = useState(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']);
    const [pullOrderProcessCode, setPullOrderProcessCode] = useState("A");
    const [pullOrderQty, setPullOrderQty] = useState({
        issueqty: 0,
        total_Bags: 0,
        a_Bags: 0,
        a_Bag_Lbs: 0,
        b_Bags: 0,
        b_Bag_Lbs: 0
    });
    const [seqNumber, setSeqNumber] = useState("");
    const [pullOrderDate, setPullOrderDate] = useState(new Date());
    const [isGetPullOrderReportPopupVisible, setIsGetPullOrderReportPopupVisible] = React.useState(false);
    const [isPullOrderReportInProgressPopupVisible, setIsPullOrderReportInProgressPopupVisible] = React.useState(false);
    const [generatedPullOrderReportFileName, setGeneratedPullOrderReportFileName] = React.useState("");
    const [isGetChargeSheetReportPopupVisible, setIsGetChargeSheetReportPopupVisible] = React.useState(false);
    const [isChargeSheetReportInProgressPopupVisible, setIsChargeSheetReportInProgressPopupVisible] = React.useState(false);
    const [generatedChargeSheetReportFileName, setGeneratedChargeSheetReportFileName] = React.useState("");
    const [connection, setConnection] = React.useState(null);
    const [pullOrderRpt, setPullOrderRpt] = React.useState(true);
    const [chargeSheetRpt, setChargeSheetRpt] = React.useState(true);
    const [bagTagsRpt, setBagTagsRpt] = React.useState(true);

    accessToken = props.oidc.user.access_token;

    const handleChangeForPullOrderReport = (e) => {
        setPullOrderRpt(e.value);
    };

    const handleChangeForChargeSheetReport = (e) => {
        setChargeSheetRpt(e.value);
    };

    const handleChangeFortBagTagsReport = (e) => {
        setBagTagsRpt(e.value);
    };

    const UpdatePullOrderProcessOnClick = () => {
        UpdatePullOrderProcess();
    };

    const UpdatePullOrderProcess = () => {
        var that = this;
        let result = confirm("<i>Process Records?</i>", "Pull Order");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Processing");
                var request = new Object();
                request.Onpullorderdate = pullOrderDate;
                request.Pullordernumber = seqNumber;
                request.Generatebagtagsreport = bagTagsRpt;
                axios.post
                (
                    `${window._env_.REACT_APP_APIS}/${routes.PullOrder.ProcessPullOrderRecords}`, request,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        }
                    }
                )
                .then((res) => {

                    if (res.data.isSuccess) 
                    {
                        var pullorderNumber = seqNumber;
                        dataGrid.current.instance().endCustomLoading();
                        fetchPullOrderData();
                        fetchPullOrderQtyData();
                        fetchSeqNumb();

                        if(bagTagsRpt)
                        {
                            window.open(
                                `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`,
                                "_blank"
                              );
                        }
                       
                        if (pullOrderRpt)
                        {
                            var report = new Object();
                            report.Name = "SOR0014";
                            report.IgnoreFormat = true;
                            var whereInfo = new Object();
                            whereInfo.FieldType = 0; //ParameterTypeEnum.String;
                            whereInfo.FieldName = "PullOrderNumber";
                            whereInfo.Operation = 3; //OperationEnum.Equal
                            whereInfo.Origin = "tblSOMASTERDATABASE.PULLORDERNUMBER";
                            whereInfo.From = pullorderNumber;
                            report.FilterWhereInfoList = [];
                            report.FilterWhereInfoList.push(whereInfo);
                            axios.post
                            (
                                `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                                report,
                                {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                },
                                }
                            ).then((res) => {
                                if (window._env_.Generate_Report_From_Remote) 
                                {
                                if (res.data.isSuccess)
                                {
                                    setIsGetPullOrderReportPopupVisible(false);
                                    setIsPullOrderReportInProgressPopupVisible(true);
                                }
                                else 
                                {
                                    alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                                }
                                
                                }
                                else 
                                {
                                if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) 
                                {
                                    if (res.data.isSuccess) 
                                    {
                                    window.open(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`, '_blank');
                                    }
                                    else 
                                    {
                                    alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                                    }
                                }
                                else 
                                {
                                    alert("Cannot generate report", "Error");
                                }
                                }
                            })
                            .catch((err) => {
                                console.log(err, "Error in Printing lot select list report.");
                            });
                        }
                        

                        if(chargeSheetRpt)
                        {
                            var report = new Object();
                            report.Name = "SOR0019";
                            report.IgnoreFormat = true;
                            var whereInfo = new Object();
                            whereInfo.FieldType = 0; //ParameterTypeEnum.String;
                            whereInfo.FieldName = "PullOrderNumber";
                            whereInfo.Operation = 3; //OperationEnum.Equal
                            whereInfo.Origin = "SOMASTERDATABASE.PULLORDERNUMBER";
                            whereInfo.From = pullorderNumber;
                            report.FilterWhereInfoList = [];
                            report.FilterWhereInfoList.push(whereInfo);
                            axios.post
                            (
                                `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                                report,
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        access_token: accessToken,
                                    }
                                }
                            ).then((res) => {
                                if (window._env_.Generate_Report_From_Remote) 
                                {
                                    if (res.data.isSuccess)
                                    {
                                        setIsGetChargeSheetReportPopupVisible(false);
                                        setIsChargeSheetReportInProgressPopupVisible(true);
                                    }
                                    else 
                                    {
                                        alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                                    }
                                }
                                else 
                                {
                                    if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) 
                                    {
                                        if (res.data.isSuccess) 
                                        {
                                            window.open(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`, '_blank');
                                        }
                                        else 
                                        {
                                            alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                                        }
                                    }
                                    else 
                                    {
                                        alert("Cannot generate report", "Error");
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err, "Error in Printing lot select list report.");
                            });
                        }
                    }
                })
                .catch((err) => {
                    dataGrid.current.instance().endCustomLoading();
                    alert(err, "Error");
                });
            }
        });
    };
    const selectAllRows = () => {
        dataGrid.selectAll();
    }
    const deSelectAllRows = () => {
        dataGrid.deselectAll();
    };
    const fetchPullOrderData = () => {
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.PullOrder.GetPullOrderData}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                recordSelectionDic = {};
                for (var i=0; i < res.data.length; i++)
                {
                    if (res.data[i].isonpullorder == true)
                    {
                        recordSelectionDic[res.data[i].refrowid] = true;
                    }
                    else
                    {
                        recordSelectionDic[res.data[i].refrowid] = false;
                    }
                }

                dataGrid.current.instance().option("dataSource", new ArrayStore({
                    data: res.data,
                    key: 'refrowid'
                }));
                
                
               
            })
            .catch((err) => {
                console.log(err, "err in fetching pull order data");
            });
    };
    const fetchPullOrderQtyData = (endloading) => {
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.PullOrder.GetPullOrderQtyData}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    }
                }
            )
            .then((res) => {
                setPullOrderQty({
                    issueqty: res?.data?.issueqty ? res?.data?.issueqty : 0 ,
                    total_Bags: res?.data?.total_Bags ? res?.data?.total_Bags : 0,
                    a_Bags: res?.data?.a_Bags ? res?.data?.a_Bags : 0,
                    a_Bag_Lbs: res?.data?.a_Bag_Lbs ? res?.data?.a_Bag_Lbs : 0,
                    b_Bags: res?.data?.b_Bags ? res?.data?.b_Bags : 0,
                    b_Bag_Lbs: res?.data?.b_Bag_Lbs ? res?.data?.b_Bag_Lbs : 0
                });
                if (endloading === true)
                {
                    dataGrid.current.instance().endCustomLoading();
                }
            })
            .catch((err) => {
                if (endloading === true)
                {
                    dataGrid.current.instance().endCustomLoading();
                }
                console.log(err, "err in fetching pull order data");
            });
    };
    
    const fetchSeqNumb = () => {
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.PullOrder.GetSequenceNumber}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    }
                }
            )
            .then((res) => {
                setSeqNumber(res.data.seqno);
            })
            .catch((err) => {
                console.log(err, "err in fetching Seq Number.");
            });
    };
    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
        .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
        .withAutomaticReconnect()
        .build();
    
        setConnection(newConnection);
        fetchPullOrderData();
        fetchPullOrderQtyData();
        fetchSeqNumb();
    }, []);

    useEffect(() => {
    
        if (connection) 
        {
          connection
          .start()
          .then((result) => {
            console.log("Connected!");
    
            connection.on("ReceiveMessage", (message) => {
              
              if (message.message.includes("SOR0014"))
              {
                setGeneratedPullOrderReportFileName(message.message);
                setIsGetPullOrderReportPopupVisible(true);
                setIsPullOrderReportInProgressPopupVisible(false);
              }
              else if (message.message.includes("SOR0019"))
              {
                setGeneratedChargeSheetReportFileName(message.message);
                setIsGetChargeSheetReportPopupVisible(true);
                setIsChargeSheetReportInProgressPopupVisible(false);
              }
            });
          })
          .catch((e) => console.log("Connection failed: ", e));
        }
    }, [connection]);

    const downloadPullOrderReport = () => {

        var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${generatedPullOrderReportFileName}`;

        const link = document.createElement("a");
        link.href = url;
        link.download = generatedPullOrderReportFileName;
        link.click();
    }

    const renderPullOrderReportPopup = () => {
        return (
        <div>
            <h6 style={{ color: "#76b4ea" }}>Generate Pull Order Report</h6>
            <p>Report has been generated Successfully Click View Report To See!.</p>
            <Button onClick={closeGetPullOrderReportPopup} className="report-btn">
            Close
            </Button>
            <Button onClick={downloadPullOrderReport} className="report-btn ml-3">
            Download Report
            </Button>
        </div>
        )
    }

    const renderPullOrderReportInProgressPopup = () => {
        return (
        <div>
            <h6 style={{ color: "#76b4ea" }}>Generate Pull Order Report</h6>
            <p>Report generation is in progess ...</p>
            <Button onClick={closePullOrderReportInProgressPopup} className="report-btn">
            Close
            </Button>
        </div>
        )
    }

    const closeGetPullOrderReportPopup = () => {
        setIsGetPullOrderReportPopupVisible(false);
        setIsPullOrderReportInProgressPopupVisible(false);
    }

    const closePullOrderReportInProgressPopup = () => {
        
        setIsPullOrderReportInProgressPopupVisible(false);
    }

    const downloadChargeSheetReport = () => {

        var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${generatedChargeSheetReportFileName}`;

        const link = document.createElement("a");
        link.href = url;
        link.download = generatedChargeSheetReportFileName;
        link.click();
    }

    const renderChargeSheetReportPopup = () => {
        return (
        <div>
            <h6 style={{ color: "#76b4ea" }}>Generate Charge Sheet Report</h6>
            <p>Report has been generated Successfully Click View Report To See!.</p>
            <Button onClick={closeGetChargeSheetReportPopup} className="report-btn">
            Close
            </Button>
            <Button onClick={downloadChargeSheetReport} className="report-btn ml-3">
            Download Report
            </Button>
        </div>
        )
    }

    const renderChargeSheetReportInProgressPopup = () => {
        return (
        <div>
            <h6 style={{ color: "#76b4ea" }}>Generate Charge Sheet Report</h6>
            <p>Report generation is in progess ...</p>
            <Button onClick={closeChargeSheetReportInProgressPopup} className="report-btn">
            Close
            </Button>
        </div>
        )
    }

    const closeGetChargeSheetReportPopup = () => {
        setIsGetChargeSheetReportPopupVisible(false);
        setIsChargeSheetReportInProgressPopupVisible(false);
    }

    const closeChargeSheetReportInProgressPopup = () => {
        
        setIsChargeSheetReportInProgressPopupVisible(false);
    }
    
    const onDateValueChanged = (e) => {
        setPullOrderDate(e.value);
    }
    const onValueChangedProcessCdSlctBx = (e) => {
        setPullOrderProcessCode(e.value);
    }

    const onSelectionChanged = (e) => {
        if (!ignoreSelectionChange)
        {
            if ((e.currentSelectedRowKeys != null && e.currentSelectedRowKeys.length === 1) || (e.currentDeselectedRowKeys != null && e.currentDeselectedRowKeys.length === 1))
            {
                var rows =  e.component.getVisibleRows();  
                var request = {key:"", values:"{\"onpullorderdate\":\"\",\"pullordercode\":\"\",\"pullordernumber\":\"\"}"};
                var rowIndex = 0;

                if (e.currentSelectedRowKeys != null && e.currentSelectedRowKeys.length === 1)
                {
                    rowIndex = e.component.getRowIndexByKey(e.currentSelectedRowKeys[0]);
                    if (rowIndex >= 0)
                    {
                        if (recordSelectionDic[e.currentSelectedRowKeys[0]] == null || recordSelectionDic[e.currentSelectedRowKeys[0]] == undefined || recordSelectionDic[e.currentSelectedRowKeys[0]] == true)
                        {
                            rowIndex = -1;
                        }
                        else
                        {
                            dataGrid.current.instance().beginCustomLoading("Processing");
                            recordSelectionDic[e.currentSelectedRowKeys[0]] = true;

                            dataGrid.current.instance().beginUpdate();
                            dataGrid.current.instance().cellValue(rowIndex, "onpullorderdate", pullOrderDate);
                            dataGrid.current.instance().cellValue(rowIndex, "pullordercode", pullOrderProcessCode);
                            dataGrid.current.instance().cellValue(rowIndex, "pullordernumber", seqNumber);
                            request.values = "{\"onpullorderdate\":\"" + pullOrderDate.toJSON() + "\",\"pullordercode\":\""+ pullOrderProcessCode + "\",\"pullordernumber\":\""+ seqNumber + "\"}";
                            
                            for(var i = 0; i < rows.length; i++) 
                            {
                                if (i != rowIndex && rows[i].data.rowid === rows[rowIndex].data.rowid && recordSelectionDic[rows[i].data.refrowid] == false) 
                                {
                                    ignoreSelectionChange = true;
                                    dataGrid.current.instance().selectRows(rows[i].data.refrowid, true);
                                    ignoreSelectionChange = false;
                                    recordSelectionDic[rows[i].data.refrowid] = true;
                                    dataGrid.current.instance().cellValue(i, "onpullorderdate", pullOrderDate);
                                    dataGrid.current.instance().cellValue(i, "pullordercode", pullOrderProcessCode);
                                    dataGrid.current.instance().cellValue(i, "pullordernumber", seqNumber);
                                }
                            }

                            dataGrid.current.instance().endUpdate();
                        }
                    }
                } 
                else if (e.currentDeselectedRowKeys != null && e.currentDeselectedRowKeys.length === 1)
                {
                    dataGrid.current.instance().beginCustomLoading("Processing");
                    rowIndex = e.component.getRowIndexByKey(e.currentDeselectedRowKeys[0]);

                    if (rowIndex >= 0)
                    {
                        if (recordSelectionDic[e.currentDeselectedRowKeys[0]] == null || recordSelectionDic[e.currentDeselectedRowKeys[0]] == undefined || recordSelectionDic[e.currentDeselectedRowKeys[0]] == false)
                        {
                            rowIndex = -1;
                        }
                        else
                        {
                            recordSelectionDic[e.currentDeselectedRowKeys[0]] = false;

                            dataGrid.current.instance().beginUpdate();
                            dataGrid.current.instance().cellValue(rowIndex, "onpullorderdate", "");
                            dataGrid.current.instance().cellValue(rowIndex, "pullordercode", "");
                            dataGrid.current.instance().cellValue(rowIndex, "pullordernumber", "");

                            for(var i = 0; i < rows.length; i++) 
                            {
                                if (i != rowIndex && rows[i].data.rowid === rows[rowIndex].data.rowid && recordSelectionDic[rows[i].data.refrowid] == true) 
                                {
                                    ignoreSelectionChange = true;
                                    dataGrid.current.instance().deselectRows(rows[i].data.refrowid);
                                    ignoreSelectionChange = false;
                                    recordSelectionDic[rows[i].data.refrowid] = false;
                                    dataGrid.current.instance().cellValue(i, "onpullorderdate", "");
                                    dataGrid.current.instance().cellValue(i, "pullordercode", "");
                                    dataGrid.current.instance().cellValue(i, "pullordernumber", "");
                                }
                            }
                            dataGrid.current.instance().endUpdate();
                        }
                    }
                }

                if (rowIndex >= 0)
                {
                    request.key = rows[rowIndex].data.rowid;
                    axios.put
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.PullOrder.UpdatePullOrderProcessFlag}`,
                        request,
                        {
                            headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().saveEditData();
                        fetchPullOrderQtyData(true);
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });
                }
            }
            else
            {
                var rows =  e.component.getVisibleRows();
                var request = {keys:[], values:"{\"onpullorderdate\":\"\",\"pullordercode\":\"\",\"pullordernumber\":\"\"}"};
                var rowIndex = 0;
                var keys = [];
                var isloading = false;

                if (e.currentSelectedRowKeys != null && e.currentSelectedRowKeys.length > 1)
                {
                    request.values = "{\"onpullorderdate\":\"" + pullOrderDate.toJSON() + "\",\"pullordercode\":\""+ pullOrderProcessCode + "\",\"pullordernumber\":\""+ seqNumber + "\"}";
                    
                    dataGrid.current.instance().beginUpdate();
                    
                    for (var i=0; i < e.currentSelectedRowKeys.length; i++)
                    {
                        rowIndex = e.component.getRowIndexByKey(e.currentSelectedRowKeys[i]);
                        
                        if (rowIndex >= 0 && recordSelectionDic[e.currentSelectedRowKeys[i]] != null && recordSelectionDic[e.currentSelectedRowKeys[i]] != undefined && recordSelectionDic[e.currentSelectedRowKeys[i]] != true)
                        {
                            if (isloading == false)
                            {
                                dataGrid.current.instance().beginCustomLoading("Processing");
                                isloading = true;
                            }
 
                            recordSelectionDic[e.currentSelectedRowKeys[i]] = true;
                            dataGrid.current.instance().cellValue(rowIndex, "onpullorderdate", pullOrderDate);
                            dataGrid.current.instance().cellValue(rowIndex, "pullordercode", pullOrderProcessCode);
                            dataGrid.current.instance().cellValue(rowIndex, "pullordernumber", seqNumber);
                            keys.push(rows[rowIndex].data.rowid);
                        }
                    }
                    
                    dataGrid.current.instance().endUpdate();
                } 
                else if (e.currentDeselectedRowKeys != null && e.currentDeselectedRowKeys.length > 1)
                {
                    dataGrid.current.instance().beginUpdate();
                    for (var i=0; i < e.currentDeselectedRowKeys.length; i++)
                    {
                        rowIndex = e.component.getRowIndexByKey(e.currentDeselectedRowKeys[i]);
                        
                        if (rowIndex >= 0 && recordSelectionDic[e.currentDeselectedRowKeys[i]] != null && recordSelectionDic[e.currentDeselectedRowKeys[i]] != undefined && recordSelectionDic[e.currentDeselectedRowKeys[i]] != false)
                        {
                            if (isloading == false)
                            {
                                dataGrid.current.instance().beginCustomLoading("Processing");
                                isloading = true;
                            }

                            recordSelectionDic[e.currentDeselectedRowKeys[i]] = false;
                            dataGrid.current.instance().cellValue(rowIndex, "onpullorderdate", "");
                            dataGrid.current.instance().cellValue(rowIndex, "pullordercode", "");
                            dataGrid.current.instance().cellValue(rowIndex, "pullordernumber", "");
                            keys.push(rows[rowIndex].data.rowid);
                        }
                    }
                    dataGrid.current.instance().endUpdate();
                }

                if (keys.length > 0)
                {
                    request.keys = keys;

                    dataGrid.current.instance().beginCustomLoading("Processing");
                    axios.put
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.PullOrder.UpdatePullOrdersProcessFlag}`,
                        request,
                        {
                            headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().saveEditData();
                        fetchPullOrderQtyData(true);
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });
                }
            }
            dataGrid.current.instance().endCustomLoading();
        }
        
    }

    const updateBagTotals = (selectedRowsData) => {

        var qty = 0.0;
        var totalBags = 0;
        var aBags = 0;
        var bBags = 0;
        var aBagLbs = 0.0;
        var bBagLbs = 0.0;

        if (selectedRowsData != null && selectedRowsData.length > 0)
        {
          for (var i=0; i < selectedRowsData.length; i++)
          {
            recordSelectionDic[selectedRowsData[i].refrowid] = true;
            qty = qty + (selectedRowsData[i].issueqty == null || selectedRowsData[i].issueqty == undefined ? 0: selectedRowsData[i].issueqty);
            aBags = aBags + selectedRowsData[i].abags;
            aBagLbs = aBagLbs + selectedRowsData[i].abagslbs;
            bBags = bBags + selectedRowsData[i].bbags;
            bBagLbs = bBagLbs + selectedRowsData[i].bbagslbs;
            totalBags = totalBags + selectedRowsData[i].totalbags; 
          }
        }
        else
        {
            for (var key in recordSelectionDic) 
            {
                recordSelectionDic[key] = false;
            }
        }
    };

    const gridKey = "08aae3dd-82cf-493a-ae19-9d1a8e0afd44";
    const [currentLayout, setCurrentLayout] = useState("Default");

    const loadState = useCallback(() => {
        return  GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout).then((state) => {
            return axios.get
            (
                `${window._env_.REACT_APP_APIS}/${routes.PullOrder.GetPullOrderData}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then(res => {
                    for (var i=0; i < res.data.length; i++)
                    {
                        if (res.data[i].isonpullorder == true)
                        {
                            state.selectedRowKeys.push(res.data[i].refrowid);
                        }
                    }
                    return state;
                })
            .catch(error => { throw "Data Loading Error" });
        })
        .catch(error => { throw "Layout Loading Error" });
    }, [currentLayout]);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    return (
        <div className="h-100" style={{ overflowY: 'hidden' }}>
            <div className="row bg-color">
                <div className="col-md-12">
                <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Pull Order Processing
                        </h6>
                      </div>
                </div>
                <div className="col-md-10">
                    <div className="row">
                        <div className="col-md-6 pt-2">
                            <div className="row" style={{paddingTop:'8px'}}>
                                <div className="col-md-5">
                                    <strong>Date</strong>
                                    <DateBox
                                        defaultValue={pullOrderDate}
                                        min={new Date(1900, 0, 1)}
                                        max={new Date(2099, 12, 31)}
                                        type="date"
                                        onValueChanged={onDateValueChanged}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <strong>Process Code</strong>
                                    <SelectBox
                                        defaultValue={processCodes.length > 0 ? processCodes[0] : ""}
                                        items={processCodes}
                                        onValueChanged={onValueChangedProcessCdSlctBx} />
                                </div>
                                <div className="col-md-4">
                                    <strong>Seq #</strong>
                                    <TextBox value={seqNumber} readOnly={true} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Total</th>
                                                <th>A Bags</th>
                                                <th>B Bags</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Bags</td>
                                                <td><NumberBox name="txtTotal_Bags" value={pullOrderQty.total_Bags} readOnly={true} /></td>
                                                <td><NumberBox name="txtA_Bags" value={pullOrderQty.a_Bags} readOnly={true} /></td>
                                                <td><NumberBox name="txtB_Bags" value={pullOrderQty.b_Bags} readOnly={true} /></td>
                                            </tr>
                                            <tr>
                                                <td>LBS</td>
                                                <td><NumberBox name="txtSumIssueQty" value={pullOrderQty.issueqty} readOnly={true} format="#,##0.00" /></td>
                                                <td><NumberBox name="txtA_Bag_Lbs" value={pullOrderQty.a_Bag_Lbs} readOnly={true} format="#,##0.00"/></td>
                                                <td><NumberBox name="txtB_bag_Lbs" value={pullOrderQty.b_Bag_Lbs} readOnly={true} format="#,##0.00"/></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="col-md-12">
                        <div className="d-flex pb-3">
                            <div className="col-md-12 mt-2 px-0 pt-2">
                                <CheckBox value={pullOrderRpt} onValueChanged={handleChangeForPullOrderReport} text="Pull Order" className="mr-2" />
                                <CheckBox value={chargeSheetRpt}  onValueChanged={handleChangeForChargeSheetReport} text="Charge Sheet" className="mr-2" />
                                <CheckBox defaultValue={bagTagsRpt} onValueChanged={handleChangeFortBagTagsReport}  text="Bag Tags" className="mr-2" />
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="col-md-12">
                                <Button text="Process Order" type="default" onClick={UpdatePullOrderProcessOnClick} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row pt-4 h-100">
                <div className="col-md-12 h-100">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        showBorders={true}
                        className="SOPullOrderGridStyle"
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        ref={dataGrid}
                        searchEnabled={true}
                        onSelectionChanged={onSelectionChanged}
                    >
                        <Export enabled={true} allowExportSelectedData={true} />
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Sorting visible={false} />
                        <Paging enabled={false} />
                        <Pager
                            visible={false}
                        />
                        <FilterRow visible={false} />
                        <FilterPanel visible={false} />
                        <HeaderFilter enabled={true} visible={false} />
                        <GroupPanel visible={false} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Selection mode="multiple" />
                        <Column dataField="onpullorderdate" dataType="date" caption="Pull Date" allowEditing={false}></Column>
                        <Column dataField="pullordernumber" caption="Seq No" allowEditing={false}></Column>
                        <Column dataField="pullordercode" caption="Charge Code" allowEditing={false}></Column>
                        <Column dataField="stratdate" dataType="date" caption="Strat Date" allowEditing={false}></Column>
                        <Column dataField="species" caption="Species" allowEditing={false}></Column>
                        <Column dataField="celltype" caption="Stock" allowEditing={false}></Column>
                        <Column dataField="prodlot" caption="Production Lot" allowEditing={false}></Column>
                        <Column dataField="seeditem" caption="Seed Item" allowEditing={false}></Column>
                        <Column dataField="warehouse" caption="Sub Inv" allowEditing={false}></Column>
                        <Column dataField="formloc" caption="Location" allowEditing={false}></Column>
                        <Column dataField="priorqty" caption="Prior" allowEditing={false}></Column>
                        <Column dataField="seedlot" caption="Seed Lot" allowEditing={false}></Column>
                        <Column dataField="issueqty" caption="Quantity" allowEditing={false}></Column>
                        <Column dataField="facility" caption="Facility" allowEditing={false}></Column>
                        
                        <Toolbar>
                            <Item name="exportButton" />
                            <Item name="columnChooserButton" />
                        </Toolbar>
                    </DataGrid>
                </div>
            </div>
            <Popup
                width={450}
                height={160}
                showTitle={false}
                title="Generate Report!"
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={isGetPullOrderReportPopupVisible}
                contentRender={renderPullOrderReportPopup}
            />
            <Popup
                width={450}
                height={160}
                showTitle={false}
                title="Generate Report!"
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={isPullOrderReportInProgressPopupVisible}
                contentRender={renderPullOrderReportInProgressPopup}
            />
            <Popup
                width={450}
                height={160}
                showTitle={false}
                title="Generate Report!"
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={isGetChargeSheetReportPopupVisible}
                contentRender={renderChargeSheetReportPopup}
            />
            <Popup
                width={450}
                height={160}
                showTitle={false}
                title="Generate Report!"
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={isChargeSheetReportInProgressPopupVisible}
                contentRender={renderChargeSheetReportInProgressPopup}
            />
        </div>
    );
};


function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PullOrderGrid);

